// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__kuSB3","productName":"Table_productName__27zro"};